import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';

import { RootState } from '../../../../store';
import { getSelectedModelForSettingsPanel } from '../../../../store/selectors/settingsPanelSelectors';
import AnalysisSettingsPanel from './analysis/AnalysisSettingsPanel';
import { FeaturePatternSettingsPanel } from './feature-pattern/FeaturePatternSettingsPanel';
import LoadSettingsPanel from './loading/LoadSettingsPanel';
import MaterialSettingsPanel from './material/MaterialSettingsPanel';
import ErrorPanel from './other/ErrorPanel';
import LoadingSpinnerPanel from './other/LoadingSpinnerPanel';
import { ProfileDefaultsSettingsPanel } from './profile-defaults/ProfileDefaultsSettingsPanel';

export type SettingsPanels =
  'loadSettings' | 'analysisSettings' | 'materialSettings' | 'featurePatternSettings' | 'profileDefaults';

const SettingsPanel: FunctionComponent<ReturnType<typeof mapStateToProps>> = (props) => {
  if (props.noModelSelected) {
    return <LoadingSpinnerPanel />;
  }

  switch (props.settingsPanelActiveTab) {
    case 'loadSettings':
      return <LoadSettingsPanel />;
    case 'analysisSettings':
      return <AnalysisSettingsPanel />;
    case 'materialSettings':
      return <MaterialSettingsPanel />;
    case 'featurePatternSettings':
      return <FeaturePatternSettingsPanel />;
    case 'profileDefaults':
      return <ProfileDefaultsSettingsPanel />;
    default:
      return <ErrorPanel error="Invalid settings panel selected." />;
  }
};

const mapStateToProps = (state: RootState) => ({
  settingsPanelActiveTab: state.panelData.settingsPanelActiveSubPanel,
  noModelSelected: getSelectedModelForSettingsPanel(state) == null,
});

export default connect(mapStateToProps)(SettingsPanel);
